import * as React from 'react';
import { Container } from 'reactstrap';

import Router from '../../config/Route';

import Footer from '../../components/Footer';
import NavBar from '../../components/NavBar';

import Notifications from '../../lib/notifications';
import { GetMe } from '../../lib/utils';

import './App.scss';

class App extends React.Component<App.IProps, App.IState> {
  componentDidMount() {
    const data = {
      closeButton: true,
      extendedTimeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      timeOut: 5000,
      toastClass: 'toast-container'
    } as ToastrOptions;

    Notifications.config(data);

    return GetMe();
  }

  render() {
    return (
      <Container fluid className="App m-0 p-0 h-100 d-flex flex-column">
        <NavBar />
        <div className="eon-redesign d-flex flex-fill flex-grow-1 flex-shrink-0">
          <Router />
        </div>
        <Footer />
      </Container>
    );
  }
}

export default App;
